import { ChromiumSnackbar } from '@chancenwerk/design/components/cr-snackbar.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { takeUntil, type Observable, type Subscription } from 'rxjs';
import { ChromiumDialog } from '../design/components/cr-dialog.js';

/**
 * @customElement chancen-dialog-mail-progress
 */
@customElement('chancen-dialog-mail-progress')
export class ChancenDialogMailProgress extends ChromiumDialog<void> {
  static override get element_name() {
    return 'chancen-dialog-mail-progress';
  }

  bqlSubscription?: () => Observable<number>;
  private _subscription?: Subscription;

  @state() private _mailSent = 0;

  override connectedCallback(): void {
    super.connectedCallback();

    if (this.bqlSubscription) {
      this._subscription = this.bqlSubscription()
        .pipe(takeUntil(this.disconnected))
        .subscribe({
          next: currentSentMails => (this._mailSent = currentSentMails),
          complete: async () => {
            await this.close();
            void ChromiumSnackbar.show('Mails wurden versandt');
          },
        });
    }
  }

  override disconnectedCallback(): void {
    super.disconnectedCallback();

    if (this._subscription) this._subscription.unsubscribe();
  }

  override heading = 'Mails werden versandt';

  override content() {
    return html`
      <x-flex space="md" crossaxis-center center>
        <cr-loader></cr-loader> <cr-text> ${this._mailSent} Mails versandt </cr-text>
        <cr-button mode="outline" @click=${() => this.close()}> Abbrechen </cr-button>
      </x-flex>
    `;
  }
}
